import { CircularProgress, type CircularProgressProps } from "@mui/material";
import { AppLoading } from "../../../../shared/components/AppLoading";
import styles from "./styles.module.css";

interface Props extends CircularProgressProps {
  progress: number;
  fileName: string;
}

export const TranscriptionProgressBar = ({
  progress,
  fileName,
  ...props
}: Props) => {
  return (
    <div className={styles["progress-bar"]}>
      <div className={styles["progress-bar-border"]}>
        <CircularProgress
          variant={"determinate"}
          value={progress}
          className={styles.loading}
          thickness={2}
          size={200}
          {...props}
        />
      </div>
      <div className={styles["progress-bar-content"]}>
        <div className={styles["progress-bar-text"]}>{progress}%</div>
        <div className={styles["progress-bar-filename"]}>{fileName}</div>
      </div>
    </div>
  );
};
